module.exports = __webpack_public_path__ + "static/12-4d1ba4b63cd89d07f3a207f6ae7de327.jpg";